import { render } from "./thankUpgradePopup.vue?vue&type=template&id=65fc7118&scoped=true"
import script from "./thankUpgradePopup.vue?vue&type=script&lang=js"
export * from "./thankUpgradePopup.vue?vue&type=script&lang=js"

import "../less/thankPopup.less?vue&type=style&index=0&id=65fc7118&scoped=true&lang=css&external"
import "./thankUpgradePopup.vue?vue&type=style&index=1&id=65fc7118&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65fc7118"]])

export default __exports__